module.exports = __webpack_public_path__ + "static/media/ring.2e7992eb.png";